import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { BulkSelection } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'
import { useDeleteTrainingMemberships } from 'modules/trainings/hooks/TrainingMemberships/useDeleteTrainingMemberships'

interface Props {
  selection: BulkSelection
}

export const DeleteParticipantsModal = ({ selection }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useParams()
  const trainingId = String(id)
  const { deleteTrainingMemberships } = useDeleteTrainingMemberships()

  const onSubmit = async () => {
    const variables =
      selection.type === 'all'
        ? {
            all: true,
            trainingId,
            ids: selection.excludedIds,
            search: selection.filters?.search,
            status: selection.filters?.status,
            teamId: selection.filters?.teamId,
            classId: selection.filters?.classId,
            dueDate: selection.filters?.dueDate,
          }
        : {
            ids: selection.ids,
          }

    const response = await deleteTrainingMemberships(variables)

    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.error'
        ),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.success'
        ),
      })

      navigate(
        navigation.trainings.list.details_revamp.view.participants.fullPath({ id: trainingId })
      )
    }
  }

  const getTitle = () => {
    if (selection.type === 'all') {
      return i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.title_all'
      )
    }
    return selection.ids.length === 1
      ? i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.title_only_one'
        )
      : i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.title',
          { count: selection.ids.length }
        )
  }

  return (
    <Modal
      title={getTitle()}
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.description'
      )}
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.participants.fullPath({ id: trainingId })
        )
      }
      footer={
        <Box gap="s8" flexDirection="row">
          <Button.Router
            to={{
              pathname: navigation.trainings.list.details_revamp.view.participants.fullPath({
                id: trainingId,
              }),
            }}
            type="secondary"
          >
            {i18n.t('common.cancel')}
          </Button.Router>
          <Button onClick={() => onSubmit()} type="negative">
            {i18n.t('common.delete')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}
